import { render } from "./designGroupTitlePreview.vue?vue&type=template&id=c57af0fa&scoped=true"
import script from "./designGroupTitlePreview.vue?vue&type=script&lang=js"
export * from "./designGroupTitlePreview.vue?vue&type=script&lang=js"

import "./designGroupTitlePreview.vue?vue&type=style&index=0&id=c57af0fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c57af0fa"]])

export default __exports__